<template>
  <v-card>
    <v-card-title :style="bannerStyle" class="py-1">
      <v-row align="center">
        <v-col cols="12" class="text-right d-none d-md-block py-0">
          <div v-if="download_link">
            <v-btn
              :href="download_link"
              target="_blank"
              class="mt-2"
              outlined
              :dark="isDark"
            >Download ready</v-btn>
          </div>
          <div v-else-if="canDownload">
            <v-btn
              title="Download files"
              icon
              small
              :dark="isDark"
              :loading="generating_zip"
              @click="downloadZip"
            >
              <v-icon small>fa-file-download</v-icon>
            </v-btn>
            <span
              v-if="generating_zip"
              :class="`ml-2 caption ${isDark ?'white--text' : ''}`"
            >Please wait...</span>
          </div>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-title :style="bannerStyle" class="py-1">
      <v-row>
        <v-col cols="12" class="text-center py-0">
          <h5 style="word-break: break-word;" :class="textStyle">{{section.title}}</h5>
        </v-col>
      </v-row>
    </v-card-title>

    <v-container class="secondary lighten-1 white--text py-0" v-if="show_feedback">
      <v-row>
        <v-col cols="4" md="3" lg="2" xl="1">
          <v-btn outlined block x-large color="orange">
            <div>
              <v-icon v-if="value.feedback.video">fa-play</v-icon>
              <v-icon v-else>fa-plus</v-icon>
              <br />
              <span class="caption">Video</span>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="8" md="9" lg="10" xl="11">
          <v-textarea
            :rows="3"
            dark
            outlined
            hide-details
            label="Feedback"
            v-model="value.feedback.description"
            @change="onChange"
          ></v-textarea>
          <div class="text-right pt-2">
            <v-btn
              small
              color="green"
              dark
              :disabled="!value.feedback.description && !value.feedback.video"
            >Send</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-tabs
      fixed-tabs
      :show-arrows="false"
      :slider-size="4"
      :dark="isDark"
      :color="isDark ? '' : 'secondary' "
      :slider-color="isDark ? 'yellow' : 'grey darken-2'"
      v-model="tab"
      v-if="morethan1tab"
    >
      <v-tab href="#tab-videos" class="tab-title" v-if="section.videos.required">
        <v-icon small>fa-play</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.videos.multiple">Videos</span>
        <span class="ml-2 d-none d-md-block" v-else>Video</span>
      </v-tab>
      <v-tab href="#tab-photos" class="tab-title" v-if="section.photos.required">
        <v-icon small>fa-image</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.photos.multiple">Photos</span>
        <span class="ml-2 d-none d-md-block" v-else>Photo</span>
      </v-tab>
      <v-tab href="#tab-documents" class="tab-title" v-if="section.documents.required">
        <v-icon small>fa-file-alt</v-icon>
        <span class="ml-2 d-none d-md-block" v-if="section.documents.multiple">Documents</span>
        <span class="ml-2 d-none d-md-block" v-else>Document</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-videos">
        <video-tab
          v-model="section.videos"
          :section="section"
          @change="onChange"
          :readonly="readonly"
        ></video-tab>
      </v-tab-item>

      <v-tab-item value="tab-photos">
        <photo-tab
          v-model="section.photos"
          :section="section"
          @change="onChange"
          :readonly="readonly"
        ></photo-tab>
      </v-tab-item>
      <v-tab-item value="tab-documents">
        <document-tab
          v-model="section.documents"
          :section="section"
          @change="onChange"
          :readonly="readonly"
        ></document-tab>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import videoTab from "@/components/portal/applicant-view/video-tab";
import photoTab from "@/components/portal/applicant-view/photo-tab";
import documentTab from "@/components/portal/applicant-view/document-tab";

export default {
  name: "PortalApplicantViewSection",
  props: ["value", "portal", "readonly", "downloads", "applicant"],
  data() {
    return {
      tab: "",
      download_link: null,
      show_feedback: false,
      generating_zip: false,
    };
  },
  components: {
    videoTab,
    photoTab,
    documentTab,
  },
  created() {
    this.setTab();
    if (this.value.feedback.video || this.value.feedback.description) {
      this.show_feedback = true;
    }
  },
  methods: {
    async downloadZip() {
        this.generating_zip = true;
      try {
        //Get job, keep checking id until available.
        let zip_job_id = await this.$api({
          url: `/viewer/portal/${
            this.portal.uid || this.portal.viewer_uid
          }/download`,
          method: "POST",
          data: {
            applicant: this.applicant || null,
            section: this.section,
          },
        });
        let zip_link;
        while (!zip_link) {
          await this.$helpers.sleep(2000);
          let zip_job = await this.$api(`/download/${zip_job_id}`);
          if (zip_job.status == "done") {
            zip_link = zip_job.link;
          }
        }

        this.download_link = zip_link;
        setTimeout(
          function () {
            this.download_link = null;
          }.bind(this),
          120000
        );
      } catch (ex) {
        alert("There was a problem generating a zip file. Please try again.");
      }
        this.generating_zip = false
    },
    async downloadZipOldtoo() {
      this.generating_zip = true;
      try {
        let zip_link = await this.$api({
          url: `/viewer/portal/${
            this.portal.uid || this.portal.viewer_uid
          }/download`,
          method: "POST",
          data: {
            applicant: this.applicant || null,
            section: this.section,
          },
        });

        this.download_link = zip_link;
        setTimeout(
          function () {
            this.download_link = null;
          }.bind(this),
          45000
        );
      } catch (ex) {
        console.error("downloadZip error", ex);
        alert("There was a problem generating a zip file.");
      }
      this.generating_zip = false;
    },
    async downloadZip_old() {
      this.generating_zip = true;
      try {
        let response = await this.$api({
          url: `/viewer/portal/${
            this.portal.uid || this.portal.viewer_uid
          }/download`,
          method: "POST",
          responseType: "blob",
          data: {
            applicant: this.applicant || null,
            section: this.section,
          },
        });

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `${this.applicant.name}-${this.section.title}.zip`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (ex) {
        alert(ex.error);
      }
      this.generating_zip = false;
    },
    onChange() {
      this.$emit("change");
    },
    setTab() {
      if (this.section.videos.files.length) {
        this.tab = "tab-videos";
      } else if (this.section.photos.files.length) {
        this.tab = "tab-photos";
      } else if (this.section.documents.files.length) {
        this.tab = "tab-documents";
      }
    },
  },
  computed: {
    canDownload() {
      if (!this.downloads) {
        return false;
      }
      return this.section.videos.files.length +
        this.section.photos.files.length +
        this.section.documents.files.length >
        0
        ? true
        : false;
    },
    morethan1tab() {
      let count = 0;
      if (this.section.videos.required) {
        count += 1;
      }
      if (this.section.photos.required) {
        count += 1;
      }
      if (this.section.documents.required) {
        count += 1;
      }
      if (count > 1) {
        return true;
      }
      return false;
    },
    uploading_videos() {
      return this.video_uploads.filter((u) => {
        return u.status !== "Done";
      });
    },
    section() {
      return this.value;
    },
    isDark() {
      return this.$helpers.lightOrDark(this.value.banner_color) === "dark";
    },
    isButtonDark() {
      return this.$helpers.lightOrDark(this.value.button_color) === "dark";
    },
    textStyle() {
      return this.isDark ? "white--text" : "secondary--text";
    },
    bannerStyle() {
      return `background: ${this.value.banner_color}`;
    },
  },
};
</script>

<style lang="scss">
.scroll-box {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
  @media only screen and (min-width: 768px) {
    max-height: 320px;
  }
  @media only screen and (min-width: 1920px) {
    max-height: 370px;
  }
  @media only screen and (max-width: 767px) {
    max-height: 250px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    max-height: 220px;
  }
}
</style>